<template>
<div>
    <a style="color: #000000; cursor: pointer; margin-top: -0.4em; padding-top: 0px; float: right;" @click="dropMenu()">
        <i class="fas fa-ellipsis-v" style="font-size:1.48em; color: #5703a5;"></i>
        <!-- <div style="background-color: #5703a5; border-radius: 38%; color: #ffffff; padding: 0.28em 0.38em;">
            <i class="fa fa-user-o" style="font-size:1.12em"></i>
        </div> -->
    </a>
     
    <div id="menu-nav" class="sidenav">
        <a href="javascript:void(0)" class="closebtn" @click="dropMenu()">&times;</a>
        <!-- <h3 style="clear:both; margin-top: -2em; margin-left: 0.71em; font:1.5em agency-fb; font-weight:200;">eShop</h3> -->
        <h3 style="clear:both; margin-top: -2em; margin-left: 0.71em; font:1.5em agency-fb; font-weight:200;">XXXX</h3>
        <div style="clear:both; margin: 1em; display: none;">
            <!-- <a href="/cart" class="btn sp-button-02 sp-button-02-lt" style="color:#000000; font-size: 16px; margin-top: 0.9em; text-transform: inherit; background-color: #f7af13; border-radius: 5px; padding: 13px 10px;" >View Shopping Cart</a> -->
        </div>
        <p style="margin-left:1em;" v-if="loggedIn"><b>{{user.user_name}}</b></p>
        <div class="m-nav" style="margin-left:0.71em;">
            <ul>
                <li style="display:inline-block;"><a href="/cart" @click="hideMenu()"><i class="fa fa-shopping-cart"></i>Shopping Cart</a></li>
                <li style="display:inline-block;"><a href="/wishlist" @click="hideMenu()"><i class="fa fa-heart"></i>Wishlist</a></li>
                <li style="display:inline-block;"><a href="/account" @click="hideMenu()"><i class="fa fa-user"></i>My Account</a></li>
            </ul>
        </div>
        <hr style="border-top:#f9f9fb solid; margin:1em; margin-top: 0.3em; margin-right: 1.73em;"/>
        <div style="margin:0 1em;">
           <p style="margin-left: 45vw; padding-right:1em; margin-top: -0.5em; font-size: 13px;"><a ><i class="fa fa-search"></i> Search For _____________ </a></p>
           <div style="clear:both"></div>
        </div>
        <ul style="display:none;">
            <li v-if="loggedIn"><a href="/account" @click="hideMenu()"><b>{{user.user_name}}</b></a></li>
            <li v-if="loggedIn"><a href="/account" @click="hideMenu()"><i class="fa fa-user"></i> Account</a></li>
            <li><a href="/timeline" @click="hideMenu()"><i class="fa fa-shopping-bag"></i> Market</a></li>
            <li><a href="/orders" @click="hideMenu()"><i class="fa fa-book"></i> Orders</a></li>
            <li v-if="loggedIn"><a href="/wishlist" @click="hideMenu()"><i class="fa fa-heart"></i> Wishlist</a></li>
            <li v-if="loggedIn"><a href="/buypoint" @click="hideMenu()"><i class="fa fa-users"></i> Shop Together</a></li>
            <li v-if="loggedIn"><a href="/login" @click="hideMenu()"><i class="fa fa-power-off"></i> Logout</a></li>
            <li v-if="!loggedIn"><a href="/login" @click="hideMenu()"><i class="fa fa-power-on"></i> Login</a></li>
            <li v-if="!loggedIn"><a href="/register" @click="hideMenu()"><i class="fa fa-power-on"></i> Register</a></li>
        </ul>
        <div>
            <div class="col-xs-12 row-01">
                <div class="col-xs-6 node01">
                    <div class="box01">
                        <a href="/orders" @click="hideMenu()" class="card-link">
                            <span><i class="fa fa-shopping-basket"></i></span>
                            <p>Recent Orders</p>
                        </a>
                    </div>
                </div>
                <div class="col-xs-6 node01">
                    <div class="box01">
                        <span><i class="fa fa-list"></i></span>
                        <p>My Lists</p>
                    </div>
                </div>
                <div class="col-xs-6 node01">
                    <div class="box01">
                        <span><i class="fa fa-credit-card" aria-hidden="true"></i></span>
                        <p>Make Payment</p>
                    </div>
                </div>
                <div class="col-xs-6 node01">
                    <div class="box01">
                        <span><i class="fa fa-shopping-bag"></i></span>
                        <p>Add Shop</p>
                    </div>
                </div>
                <div class="col-xs-6 node01">
                    <div class="box01">
                        <span><i class="fa fa-cubes"></i></span>
                        <p>Manage Shop</p>
                    </div>
                </div>
                <div class="col-xs-6 node01">
                    <div class="box01">
                        <span><i class="fa fa-upload"></i></span>
                        <p>Upload Product</p>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <div style="margin:1.71em;">
            <p>Search For<br>
            _________________Men Wears</p>
            <p>Select Type (if sub)<br>
            _________________Trousers</p>
            <p>Pick Size(if sizes) or Color (if colors) + all_option<br>
            _________________Trousers</p>
            
            <button class="btn sp-button-sm btn-sm">Go >> </button>
            
        </div>
        <div class="bottomnav m-nav">
            <div>
                <ul style="margin:0; padding:0px;">
                    <li style="display:inline-block;"><a href="/notifications" @click="hideMenu()"><i class="fa fa-bell"></i><sup v-if="notifications_alert > 0" class="notify-alert">{{notifications_alert}}</sup><span>Notifications &amp; Messages</span></a></li>
                    <li style="display:inline-block;" v-if="loggedIn"><a href="/login" @click="hideMenu()"><i class="fa fa-power-off"></i> Logout</a></li>
                    <li style="display:inline-block;" v-if="!loggedIn"><a href="/login" @click="hideMenu()"><i class="fa fa-power-on"></i> Login</a></li>
                    <li style="display:inline-block;" v-if="!loggedIn"><a href="/register" @click="hideMenu()"><i class="fa fa-power-on"></i> Register</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>
<style>
.menu-nav {background: #ffffff;}
.sidenav ul {padding: 0;}
.sidenav ul li{display:block; list-style: none; text-align: left; margin:5px;}
.sidenav ul li a{
    text-align: left;
    /* width: 100%; */
    color: inherit;
    font-size: 14px;
    padding-left: 8px;
}
.sidenav ul li a i{padding-right: 0.7em;}
.m-nav ul li a{
    font-size: 13px;
    padding-left: 2px;
}
.m-nav ul li a i{padding-right: 0.5em;}
/*sidenav*/

.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  /* left: 0; */
  right: 0;
  background-color: #ffffff;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}

.sidenav a {
  /* padding: 8px 8px 8px 32px;
  font-size: 25px; 
  color: #818181;*/
  color: inherit;
  text-decoration: none;
  display: block;
  transition: 0.3s;
}

.sidenav a:hover {
  color: #f1f1f1;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}

/*-----*/

.node01{
    text-align: center;
    margin: 0;
    padding: 0;
}
.box01{
    border: #f9f9fb solid;
    padding: 1em;
    margin-right: 1em;
    margin-bottom: 1em;
}
.box01 a{
    padding: 0;
    text-decoration: none;
    font-size: inherit;
    color: #000000;
    display: block;
}
.box01 span i{
    font-size: 32px;
}
.box01 p{
    margin-top: 0.5em;
}
.bottomnav {
    display: block;
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #fafafa;
    z-index: 3;
    overflow: hidden;
    text-align: center;
    border-top: #eee4e4 solid 1px;
}
/*----*/
</style>
<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'Account',
    data () {
        return {
            user:{},
            loggedIn:false,
            notifications_alert:0,
        }
    },
    methods:{
        dropMenu(){
            // let m = document.getElementById("menu-nav").style.display;
            // if(m == "block"){
            //     document.getElementById("menu-nav").style.display = "none";
            // }else{
            //     document.getElementById("menu-nav").style.display = "block";
            // }

            let w = document.getElementById("menu-nav").style.width;
            // if(w == "250px"){
            if(w == "100vw"){
                document.getElementById("menu-nav").style.width = "0px";
            }else{
                document.getElementById("menu-nav").style.width = "100vw";
                // document.getElementById("menu-nav").style.width = "250px";
            }

            // document.getElementById("menu-nav").style.display = "block";
        },
        hideMenu(){
            document.getElementById("menu-nav").style.display = "none";
        },
        preset() {
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.loggedIn = true;
                    self.user = value;
                }
            });
        },

    },
    created: function () {
        this.preset();
    }
}
</script>





// WEBPACK FOOTER //
// account-menu.vue?31206855